var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewTab = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.36612 3.36612C3.60054 3.1317 3.91848 3 4.25 3H8.25C8.66421 3 9 2.66421 9 2.25C9 1.83579 8.66421 1.5 8.25 1.5H4.25C3.52065 1.5 2.82118 1.78973 2.30546 2.30546C1.78973 2.82118 1.5 3.52065 1.5 4.25V19.75C1.5 20.4793 1.78973 21.1788 2.30546 21.6945C2.82118 22.2103 3.52065 22.5 4.25 22.5H19.75C20.4793 22.5 21.1788 22.2103 21.6945 21.6945C22.2103 21.1788 22.5 20.4793 22.5 19.75V15.75C22.5 15.3358 22.1642 15 21.75 15C21.3358 15 21 15.3358 21 15.75V19.75C21 20.0815 20.8683 20.3995 20.6339 20.6339C20.3995 20.8683 20.0815 21 19.75 21H4.25C3.91848 21 3.60054 20.8683 3.36612 20.6339C3.1317 20.3995 3 20.0815 3 19.75V4.25C3 3.91848 3.1317 3.60054 3.36612 3.36612Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 6V0.75C18 0.335786 17.6642 0 17.25 0C16.8358 0 16.5 0.335786 16.5 0.75V6H11.25C10.8358 6 10.5 6.33579 10.5 6.75C10.5 7.16421 10.8358 7.5 11.25 7.5H16.5V12.75C16.5 13.1642 16.8358 13.5 17.25 13.5C17.6642 13.5 18 13.1642 18 12.75V7.5H23.25C23.6642 7.5 24 7.16421 24 6.75C24 6.33579 23.6642 6 23.25 6H18Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-tab.ecb6a0813916753ddb36a703d2442e86.svg";